export default {
  dataSetName: 'Projekte',
  dataName: 'Projekt',
  head: [
    {
      label: 'Projektnummer',
      key: 'projectNumber',
      col: 3,
      leftAlign: true,
    },
    {
      label: 'Projektname',
      key: 'projectName',
      leftAlign: true,
      col: 5,
      linkTo: '/projects',
    },
    {
      label: 'Summe brutto (inkl. MwSt.)',
      key: 'projectSumBrutto',
      col: 4,
      unit: 'EUR',
    },
  ],
}
